






































import { Vue, Component, Prop } from 'vue-property-decorator';
import { actionsEvent } from '@/setup';
import { Funcionalidades } from '@/config/funcionalidades';
import { Snotify } from '@/snotify/Snotify';
import Confirmation from '@/components/Confirmation.vue';
import { fetchAtenciones } from './../fetchAtenciones';
const { AgGridVue } = require('ag-grid-vue');
import {
  GridOptions,
  GridApi,
  GridReadyEvent,
  ICellRendererParams,
  ColDef,
  ColumnApi,
  CellClickedEvent,
} from 'ag-grid-community';
import { LoadingService } from '@/services/loadingService';
import { DataApi } from '../models/AtencionesBase.model';
interface ContextMsg {
  title?: string;
  msg?: string;
  attention?: DataApi;
  btnConfirmation?: string;
}
@Component({ components: { GridComponent: AgGridVue, Confirmation } })
export default class ProductsTab extends Vue {
  @Prop({ required: true, default: [] }) data!: DataApi[];
  @Prop({ required: true, default: [] }) data_full!: DataApi;
  readonly funcionalidad: Funcionalidades = Funcionalidades.Atenciones;
  readonly $snotify: Snotify = null;
  readonly loadingService = new LoadingService();

  columnApi: any = null;
  gridOptions: GridOptions = null;
  gridEvent: any = null;
  gridApi: GridApi = null;
  columnDefs: ColDef[] = [];
  listData: any = [];
  quickSearch: string = '';
  dialogPopUp: boolean = false;
  contextPopUp: ContextMsg = {};
  confirmations: number = 0;

  constructor() {
    super();
    this.columnDefs = this.colsGrid();

    this.gridOptions = {
      columnDefs: this.columnDefs,
      pagination: true,
      rowMultiSelectWithClick: true,
      rowSelection: 'multiple',
      paginationPageSize: 25,
      cacheBlockSize: 25,
      overlayNoRowsTemplate: 'No hay filas para mostrar',
      onGridReady: this.handleMainGridReady,
    };
  }
  generaActionsEvent() {
    actionsEvent.onEliminar(this.handleEliminar);
  }
  handleEliminar(params: any) {
    console.log(params);
  }
  handleMainGridReady(event: GridReadyEvent): void {
    this.gridApi = event.api;
    this.columnApi = event.columnApi;
    this.gridEvent = event;
    this.gridApi.setRowData(this.data);
    this.gridApi.setDomLayout('autoHeight');
  }

  handleSearch() {
    this.gridApi.setQuickFilter(this.quickSearch);
    this.gridApi.setDomLayout('autoHeight');
  }
  showAlerta(): void {
    const selectedRowns = this.gridApi.getSelectedRows();
    if (!selectedRowns.length) {
      this.$snotify.error('Debe seleccionar al menos un registro');
      return;
    }
    this.dialogPopUp = true;
    this.contextPopUp = {
      title: 'Eliminar productos',
      msg: `¿Está seguro que desea eliminar los productos seleccionados para la Atención N°${this.data_full.atenumero} de la Nota de Ventas ${this.data_full.ndvnombre}?`,
      attention: null,
      btnConfirmation: 'Confirmar',
    };
  }
  handleShowPopUp(confirmation: boolean): void {
    if (!confirmation) return this.clearDataPopUp();
    this.confirmations++;
    this.validateSatateValue({
      confirmations: this.confirmations,
      registros: this.contextPopUp.attention,
    });
  }
  clearDataPopUp(): void {
    this.dialogPopUp = false;
    this.confirmations = 0;
    this.contextPopUp = {};
  }
  validateSatateValue({
    confirmations,
    registros: registros,
  }: {
    confirmations: number;
    registros: any;
  }): void {
    if (confirmations === 1) {
      this.dialogPopUp = false;
      this.contextPopUp.title = 'Aviso Importante';
      this.contextPopUp.msg =
        'Esta acción eliminará de forma permanente los registros seleccionados. Una vez realizada, deberá eliminar manualmente los productos correspondientes en INET.';
      this.contextPopUp.btnConfirmation = 'Continuar';
      setTimeout(() => (this.dialogPopUp = true), 800);
    }
    if (confirmations === 2) {
      this.handleDelete();
      this.clearDataPopUp();
    }
  }
  async handleDelete(): Promise<void> {
    this.loadingService.showLoading();
    let selectedRowns = this.gridApi.getSelectedRows();
    let data: any = {
      endpoint: 'delete_products',
      body: {
        productos_seleccionados: selectedRowns,
        atenumero: this.data_full.atenumero,
        userId: this.getUserID().toString(),
        modulo_id: 253,
      },
    };
    return await fetchAtenciones(data)
      .then(response => {
        const { CODIGO_RESPUESTA, MENSAJE_RESPUESTA, LISTA } = response.data;
        if (CODIGO_RESPUESTA != '1' || MENSAJE_RESPUESTA === 'SIN DATA') {
          return;
        }
        this.$snotify.success(MENSAJE_RESPUESTA, { timeout: 3000 });
        this.$emit('closeEvent');
        return;
      })
      .catch((error: Error) => {
        throw error;
      })
      .finally(() => {
        this.loadingService.hideLoading();
      });
  }
  getUserID(): any {
    let user = localStorage.getItem('user');
    let id = JSON.parse(user.replace(/'/g, '"')).id;
    return id;
  }
  private colsGrid(): ColDef[] {
    const fields = [
      'Número',
      'Línea',
      'porducto INET',
      'Tipo de Producto',
      'Cantidad',
      'Precio Unidad',
      'Precio Bruto',
      'Precio Neto',
      'IVA Línea',
      'Total Línea',
    ];

    return Object.keys(this.data[0])
      .filter(col => !['ndvnumero', 'STATUS', 'TOTAL_REGISTROS'].includes(col))
      .map((col, i) => {
        const baseConfig = {
          headerName: fields[i],
          field: col,
          cellStyle: { textAlign: 'left' },
          resizable: true,
          width: 220,
          minWidth: 100,
        };

        if (fields[i] === 'Número') {
          return {
            ...baseConfig,
            headerCheckboxSelection: true,
            checkboxSelection: true,
            headerCheckboxSelectionFilteredOnly: true,
          };
        }

        return baseConfig;
      });
  }
}
